import * as React from 'react';
import { Paragraph2 } from '@cian/ui-kit/typography';
import * as style from './BasicInfo.css';
import { BasicInfoLink } from './parts/BasicInfoLink';

export interface IBasicInfoProps {
  data: IBasicInfoData[];
  onLinkClick(title: string): void;
}

export interface IBasicInfoData {
  title: string;
  value: string;
  logoUrl?: string;
  linkUrl?: string | null;
}

export const BasicInfo: React.FC<IBasicInfoProps> = props => {
  const { data, onLinkClick } = props;

  return (
    <div className={style['container']}>
      <div className={style['basic-info']}>
        {data.map(({ title, value, logoUrl, linkUrl }) => (
          <div className={style['item-wrapper']} key={title}>
            <div className={style['item']}>
              {logoUrl && <div className={style['logo']} style={{ backgroundImage: `url(${logoUrl})` }} />}
              <div>
                <Paragraph2 color={'white_60'}>{title}</Paragraph2>
                {linkUrl ? (
                  <BasicInfoLink text={value} linkUrl={linkUrl} onClick={() => onLinkClick(title)} />
                ) : (
                  <Paragraph2 color={'white_100'} fontWeight={'bold'}>
                    {value}
                  </Paragraph2>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
